import { appBootstrapConfigSchema, type AppBootstrapConfig, type UserSession } from '@lilith-arcana-os/domain';

declare global {
  interface Window {
    LilithArcanaConfig?: unknown;
  }
}

const normalizeSession = (session: Record<string, unknown>): Record<string, unknown> => {
  const normalized = { ...session };

  if (normalized.wpUserId === null) {
    delete normalized.wpUserId;
  }

  if (normalized.displayName === null) {
    delete normalized.displayName;
  }

  if (normalized.role === null) {
    delete normalized.role;
  }

  return normalized;
};

export const getBootstrapConfig = (): AppBootstrapConfig => {
  const rawConfig =
    typeof window !== 'undefined' && typeof window.LilithArcanaConfig === 'object'
      ? (window.LilithArcanaConfig as Record<string, unknown>)
      : {};

  const defaultConfig: AppBootstrapConfig = {
    restBase:
      typeof import.meta.env.VITE_LILITH_REST_BASE === 'string'
        ? import.meta.env.VITE_LILITH_REST_BASE
        : '/wp-json/lilith-arcana/v1',
    nonce: '',
    currentUser: {
      isLoggedIn: false,
      nonce: '',
    },
    featureFlags: {
      pwaEnabled: true,
      hostedLlmEnabled: true,
      localLmStudioEnabled: false,
      symbolicFallbackEnabled: true,
    },
    llmCapabilities: {
      currentProvider: 'symbolic-only',
      providers: ['hosted-mini', 'external-api', 'symbolic-only', 'lm-studio-local'],
    },
    appVersion:
      typeof import.meta.env.VITE_LILITH_APP_VERSION === 'string'
        ? import.meta.env.VITE_LILITH_APP_VERSION
        : '0.1.0',
    pluginUrl:
      typeof import.meta.env.VITE_LILITH_PLUGIN_URL === 'string'
        ? import.meta.env.VITE_LILITH_PLUGIN_URL
        : '/wp-content/plugins/lilith-arcana-os',
    assetBase:
      typeof import.meta.env.VITE_LILITH_PLUGIN_URL === 'string'
        ? `${import.meta.env.VITE_LILITH_PLUGIN_URL}/build/`
        : '/wp-content/plugins/lilith-arcana-os/build/',
    pwaEnabled: true,
  };

  const normalizedConfig = {
    ...defaultConfig,
    ...rawConfig,
    currentUser:
      rawConfig.currentUser && typeof rawConfig.currentUser === 'object'
        ? normalizeSession(rawConfig.currentUser as Record<string, unknown>)
        : defaultConfig.currentUser,
  };

  return appBootstrapConfigSchema.parse(normalizedConfig);
};

export const buildLoginUrl = (): string => {
  if (typeof window === 'undefined') {
    return '/wp-login.php';
  }

  return `/wp-login.php?redirect_to=${encodeURIComponent(window.location.href)}`;
};

export const getCurrentUserFromBootstrap = (): UserSession => getBootstrapConfig().currentUser;
